export const iconFontAwesomeBuildingsVihara = (
	<i className="fa-solid fa-vihara"></i>
);
